var wFlag=true
if(window.innerWidth<750){
    wFlag=false
    $('.box3_video').attr({
        autoplay: true,
        loop: true
    });
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<21;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${i}.avif?v=1760511088`;
    }
};
preloadImages()

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

$(()=>{
    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top',
            end:'+=60%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box3_mask',{scale:2.5,opacity:0})
                .from('.box3_item',{opacity:0,y:'2rem'})
        })

        var $video = $('.box3_video');
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top+=60% top',
            end:'+=80%',
            scrub:true,
            onUpdate:(self)=>{
                //$video[0].duration
                $video[0].currentTime = self.progress * 4.64;
            },
            // markers:true,
        })

        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top',
            end:'+=160%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box3_mask',
            start:'top bottom-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
            animation:gsap.timeline()
                .from('.box3_mask',{scale:2.5,opacity:0})
        })
    }

    $('.box5_item div').hover(function(){
        $(this).addClass('box5_active').siblings().removeClass('box5_active')
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box_border',
            start:'top center',
            end:'+=60%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box5',{opacity:0,pointerEvents:'none'})
                .from('.box5_title',{scale:5,opacity:0},'-=50%')
                .from('.box5_item',{y:'2rem',opacity:0},'-=50%')
        })

        ScrollTrigger.create({
            trigger:'.box_border',
            start:'top top+=5%',
            end:'+=50%',
            pin:true,
        })
    }else{
        showUp('.box5_title')
    }

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .to('.box6_icon1',{x:0,y:0,duration:0.5})
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box6_rMask',{scale:0,duration:0.5})
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .to('.box6_icon2',{x:0,y:0,duration:0.5})
    })
    
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top top+=5%',
            end:'+=80%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 19);
                $('.box7_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${index+1}.avif?v=1760511088`) 
            },
            animation:gsap.timeline()
                .to('.box7_text1',{x:0,y:0})
                .to('.box7_text2',{x:0,y:0},'<')
        })
        
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top+=100% top+=5%',
            end:'+=100%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box7_img',{opacity:0})
                .to('.box7_text',{opacity:0},'<')
                .from('.box8_items .box8_item:first-child',{scale:0,duration:0.2},'-=50%')
                .from('.box8_items .box8_item:last-child',{opacity:0})
                .from('.box8_title',{opacity:0},'<')
                .to('.box8_items',{x:'-55%',duration:0.5})
        })
        
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top top+=5%',
            end:'+=220%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top center',
            end:'+=60%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 19);
                $('.box7_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${index+1}.avif?v=1760511088`) 
            },
            animation:gsap.timeline()
                .to('.box7_text1',{x:0,y:0})
                .to('.box7_text2',{x:0,y:0},'<')
        })
        
        showUp('.box8_title')
        showUp('.box8_items .box8_item:first-child')
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top top+=5%',
            end:'+=60%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to('.box8_items',{x:'-50%'})
        })
    }

    ScrollTrigger.create({
        trigger:'.box9',
        start:wFlag?'top top+=40%':'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // scrub:1,
        animation:gsap.timeline()
            .from('.box9_bg',{clipPath:wFlag?'circle(100% at 48% 100%)':'circle(115% at 50% 100%)'})
            .from('.box9_img1',{rotate:'0deg'})
            .from('.box9_img2',{rotate:'-16deg',x:'-25%',y:'-22%',opacity:0},'<')
            .from('.box9_text',{y:'2rem',opacity:0})
    })

    showUp('.box10_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10_item',
            start:'top bottom-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
            animation:gsap.timeline()
                .from('.box10_item',{opacity:0,y:'2rem',stagger:0.2})
        })
    }else{
        new Swiper('.box10Swiper', {
            slidesPerView: 1.25,
            centeredSlides: true,
            autoplay:true,
            loop:true
        })
    }

    showUp('.box11_title')

    showUp('.box12_title')

    if(!wFlag){
        ScrollTrigger.create({
            trigger:'.box12_left',
            start:'top top+=5.6%',
            end:'+=45%',
            pin:true,
            pinSpacing: false
        })
    }

    showUp('.specs_content')

    showUp('.pi_item')
})

//box9_1
new Swiper('.box9_1Swiper', {
    speed:wFlag?12000:8000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        //waitForTransition: false,
    },
    slidesPerView :wFlag?6:2,
    loop:true
})

new Vue({
    el:'#flavor',
    data(){
        return {
            active:0,
            popup:false,
            data:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Tropical_Gush.avif?v=1760597630',
                    title:'Tropical Gush',
                    text:'A juicy tropical mix bursting with sweet and tangy freshness.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/1._Tropical_Gush.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2.5.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4.5.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Strawberry_Kiwi.avif?v=1760597630',
                    title:'Strawberry Kiwi',
                    text:'Sweet strawberry blended with tangy kiwi for a refreshing duo.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2.Strawberry_Kiwi.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2.5.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4.5.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Miami_Mint.avif?v=1760597630',
                    title:'Miami Mint',
                    text:'Bold mint flavour with maximum cooling power.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/3.Miami_Mint.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2_b6dad337-9232-47c9-8c60-7e4641ad5c0b.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/5.png?v=1760597721'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Clear.avif?v=1760597630',
                    title:'Clear',
                    text:'A clean and simple vape with no added flavour.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4._Clear.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/1_0912f5cc-bc15-48eb-a599-bfdadd51ca36.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/3.5.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Iced_Coffee.avif?v=1760597630',
                    title:'Iced Coffee',
                    text:'A chilled coffee hit with balanced sweetness and refreshing ice.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/5.ICED_COFFEE.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2.5.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4.5.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Tobacco.avif?v=1760597630',
                    title:'Tobacco',
                    text:'A pure, authentic tobacco flavour with no sweetness or cooling.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/6.Tobacco.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/0.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/0.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Blue_Razz_Ice.avif?v=1760597630',
                    title:'Blue Razz Ice',
                    text:'Sweet and tangy blue raspberry with a refreshing icy finish.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/7.Blue_Razz_Ice.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/White_Gummy.avif?v=1760597631',
                    title:'White Gummy',
                    text:'Fruity candy flavour with juicy sweetness and a cool twist.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/8.White_Gummy.avif?v=1760597686',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/3.5.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Triple_Berry_Ice.avif?v=1760597630',
                    title:'Triple Berry Ice',
                    text:'A trio of berries blended into a sweet, tangy, and icy burst.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/9.Triple_Berry_Ice.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/3.5.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Sour_Apple_Ice.avif?v=1760597630',
                    title:'Sour Apple Ice',
                    text:'Crisp green apple with a sour punch and icy freshness.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/10.Sour_Apple_Ice.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Watermelon_Lime.avif?v=1760597630',
                    title:'Watermelon Lime',
                    text:'Juicy watermelon meets zesty lime for a sweet and tangy combo.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/11.Watermelon_Lime.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/5.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4_c74993d1-14be-4ba7-aeba-bbaf85661b60.png?v=1760597722'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/Peach_Mango_Ice.avif?v=1760597631',
                    title:'Peach Mango Ice',
                    text:'Sweet peach and ripe mango blended with a frosty tropical twist.',
                    bg:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/12.Peach_Mango_Ice.avif?v=1760597687',
                    icon1:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/2.5.png?v=1760597721',
                    icon2:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/4.5.png?v=1760597722'
                },
            ]
        }
    },
    mounted(){
        const preloadImages = () => {
            for(let i=0;i<this.data.length;i++){
                var img1 = new Image();
                var img2 = new Image();
                var img3 = new Image();
                var img4 = new Image();
                img1.src = this.data[i].img;
                img2.src = this.data[i].bg;
                img3.src = this.data[i].icon1;
                img4.src = this.data[i].icon1;
            }
        };
        preloadImages()
    }
})